import { MAX_AUTO_STOP_MINUTES, MIN_AUTO_STOP_MINUTES } from '@/pages/workgroup/form/setting/constants';

/** Empty or digits only. Rejects +, ++, -, e, decimals, and other symbols. */
export function isUnsignedIntegerInput(value: string): boolean {
  return value === '' || /^\d+$/.test(value);
}

export function validateAutoStopMinutes(value: unknown): true | string {
  if (typeof value === 'string' && value !== '' && !/^\d+$/.test(value)) {
    return 'Plus and minus signs are not allowed';
  }

  const n = Number(value);
  if (value == null || value === '' || Number.isNaN(n)) {
    return 'This field is required';
  }
  if (!Number.isInteger(n)) {
    return 'Must be an integer';
  }
  if (n < MIN_AUTO_STOP_MINUTES) {
    return `The minimum auto suspend waiting time is ${MIN_AUTO_STOP_MINUTES} minutes`;
  }
  if (n > MAX_AUTO_STOP_MINUTES) {
    return `The maximum auto suspend waiting time is ${MAX_AUTO_STOP_MINUTES} minutes`;
  }
  return true;
}
